import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { INotificationDelegate } from '../../../../../global/helpers/notification_delegate';

class PlanFeedbackAcceptedAllPopup {
  private open: boolean = false;
  private advisorLabel: string = 'advisor';

  constructor(
    private $state: any,
    private $element: ng.IAugmentedJQuery,
    private $timeout: ng.ITimeoutService,
    private ngAPNotificationDelegate: INotificationDelegate,
    private appConfigModel: any,
    private changeSuggestedPlanStatusCommand: ICommand
  ) {}

  $onChanges() {
    this.advisorLabel = _4.get(this.appConfigModel, 'model.member_configs.advisor_label', 'advisor');
  }

  openedChanged(event: any) {
    const popupOpened = event.detail.value;
    if (popupOpened) {
      return;
    }
    this.changeSuggestedPlanStatusCommand('RESOLVED')
      .then(() => {
        this.ngAPNotificationDelegate.success('Successfully applied suggestions to your plan.');
        this.$timeout(() => {
          this.$state.go('my.planner.plan.default');
        }, 300);
      })
      .catch((error) => {
        this.ngAPNotificationDelegate.error(`Unable to apply suggestion to your plan.`);
      });
  }

  clickedGotoMyPlan() {
    this.open = false;
  }
}

angular.module('capability-ng-academic-planner').component('planFeedbackAcceptedAllPopup', {
  templateUrl:
    'capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_accepted_all_popup/plan_feedback_accepted_all_popup.html',
  controller: PlanFeedbackAcceptedAllPopup,
  bindings: {
    open: '<'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_accepted_all_popup/plan_feedback_accepted_all_popup.ts